import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { SlClose } from "react-icons/sl";
import ReactPlayer from 'react-player'; // Import for video playback
import { useDispatch, useSelector } from "react-redux";
import { fetchVideoGalleryData } from "../../redux/slicer/gallerySlice";

function VideoGallery() {
    const dispatch = useDispatch();
    const {
        data: galleryData,
        loading: galleryLoading,
        error: galleryError,
    } = useSelector((state) => state.gallery.video);

    useEffect(() => {
        dispatch(fetchVideoGalleryData());
    }, [dispatch]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedAlbum, setSelectedAlbum] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);
    const [playingVideoId, setPlayingVideoId] = useState(null); // State to track the currently playing video ID

    const openModal = (album) => {
        setSelectedAlbum(album);
        setIsModalOpen(true);
        setCurrentSlide(0);
        setPlayingVideoId(null); // Reset playing video ID when the modal is opened
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedAlbum(null);
        setPlayingVideoId(null); // Reset playing video ID when the modal is closed
    };

    const handlePlayPause = (videoId) => {
        setPlayingVideoId(prevId => prevId === videoId ? null : videoId); // Toggle play/pause by updating the currently playing video ID
    };

    const handleVideoPlay = (videoId) => {
        setPlayingVideoId(videoId);  // Set the currently playing video ID when a video starts playing
    };

    const handleVideoPause = (videoId) => {
        setPlayingVideoId(null); // Pause the currently playing video if the video is paused
    }

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next) => {
            setCurrentSlide(next);
            setPlayingVideoId(null); // Pause the currently playing video when the slide changes
        },
    };

    if (galleryLoading) {
        return <div>Loading...</div>;
    }

    if (galleryError) {
        return <div>Error: {galleryError}</div>;
    }

    return (
        <div className="container mx-auto p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {galleryData.map((album) => (
                    <div key={album.album_id} className="shadow-lg rounded-lg bg-white" onClick={() => openModal(album)}>
                        {album.videos && album.videos.length > 0 ? (
                            <>
                                {console.log("Video URL:", album.videos[0]?.video_url)} {/* Debug: Check the URL */}
                                <ReactPlayer
                                    url={album.videos[0]?.video_url}
                                    playing={false} // Set to autoplay
                                    controls={false} // Remove controls
                                    width="100%"
                                    height="200px"
                                    style={{ objectFit: 'cover' }}
                                    muted={true} // Mute the video, as autoplay with sound is often restricted
                                    onError={(err) => console.error("ReactPlayer error:", err)} // Check if there is error
                                    light={false}
                                />
                            </>
                        ) : (
                            <div className="w-full h-48 bg-gray-200 flex items-center justify-center">
                                No Videos in Album
                            </div>
                        )}
                        <div className="p-4">
                            <h2 className="font-bold text-lg mb-2 font-titillium">{album.album_name}</h2>
                            <button
                                onClick={() => openModal(album)}
                                className="text-primary-color font-semibold hover:underline"
                            >
                                View Album
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Popup Modal */}
            {isModalOpen && selectedAlbum && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
                    <div className="relative max-w-5xl w-full bg-black rounded-lg shadow-lg">
                        {/* Album Title */}
                        {/* <div className="absolute top-4 left-4 text-white text-2xl font-bold">
                            {selectedAlbum.album_name}
                        </div> */}

                        {/* Slider */}
                        {selectedAlbum.videos && selectedAlbum.videos.length > 1 ? (
                            <Slider {...sliderSettings} ref={sliderRef}>
                                {selectedAlbum.videos.map((video) => (
                                    <div key={video.video_id} className="flex justify-center items-center">
                                        <ReactPlayer
                                            url={video.video_url}
                                            playing={playingVideoId === video.video_id} // Use playingVideoId for the playing prop
                                            controls
                                            width="100%"
                                            height="500px"
                                            style={{ backgroundColor: 'black' }}
                                            playIcon={
                                                <button className="text-white text-5xl" onClick={() => handlePlayPause(video.video_id)}>
                                                    {playingVideoId === video.video_id ? "❚❚" : "▶"} {/*Change the button to play pause depending on condition*/}
                                                </button>
                                            }
                                            onClickPreview={() => handlePlayPause(video.video_id)}
                                            onPlay={() => handleVideoPlay(video.video_id)}   // Set playingVideoId when a video starts playing
                                            onPause={() => handleVideoPause(video.video_id)} // Pause the currently playing video if the video is paused
                                        />
                                    </div>
                                ))}
                            </Slider>
                        ) : selectedAlbum.videos && selectedAlbum.videos.length === 1 ? (
                            // Display single video without slider
                            <div className="flex justify-center items-center">
                                <ReactPlayer
                                    url={selectedAlbum.videos[0].video_url}
                                    playing={playingVideoId === selectedAlbum.videos[0].video_id} // Use playingVideoId for the playing prop
                                    controls
                                    width="100%"
                                    height="500px"
                                    style={{ backgroundColor: 'black' }}
                                    playIcon={
                                        <button className="text-white text-5xl" onClick={() => handlePlayPause(selectedAlbum.videos[0].video_id)}>
                                            {playingVideoId === selectedAlbum.videos[0].video_id ? "❚❚" : "▶"} {/*Change the button to play pause depending on condition*/}
                                        </button>
                                    }
                                    onClickPreview={() => handlePlayPause(selectedAlbum.videos[0].video_id)}
                                    onPlay={() => handleVideoPlay(selectedAlbum.videos[0].video_id)}    // Set the currently playing video
                                    onPause={() => handleVideoPause(selectedAlbum.videos[0].video_id)}   // Pause the currently playing video if the video is paused
                                />
                            </div>
                        ) : (
                            <div>No videos available in this album.</div>
                        )}

                        {/* Bottom-Right Close Button */}
                        <div className="absolute top-4 right-4">
                            <button
                                onClick={closeModal}
                                className=" text-white text-3xl font-semibold px-4 py-2 rounded  hover:text-red-600"
                            >
                                <SlClose />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default VideoGallery;